module.exports = __webpack_public_path__ + "static/media/link.eca49b05.svg";